export default __webpack_public_path__ + "static/media/bg-7of7.0544230e.svg";